module.exports = __webpack_public_path__ + "static/media/logo153.610b2d5c.png";